/**
 * Created by CoolGuy on 2017/7/16.
 */
/**
 * Created by coolguy on 2017/7/5.
 */
import React from 'react';
import {connect} from 'react-redux';
import {Modal,message} from 'antd';
import AjaxAction from '../../actions/AjaxAction';
import actions from '../../actions';
const defaultState = {};
const getCapital = (name)=> {
    return name.slice(0, 1).toUpperCase() + name.slice(1);
};
export default (props)=>(Composed)=>
    connect((state)=>{
        return {
            showAddCommon: typeof props.dispatchName != 'undefined' ? state.ui[props.dispatchName] : state.ui.showAddCommon,
            current: state['current' + getCapital(props.type)]
        };
    })(
        class extends React.Component {
            state = defaultState;
            setKeyValue = (key, value, callback) => {
                //console.log(key,value);
                let obj = {
                    [key]: value
                };
                this.setState(obj, ()=> {
                    if (typeof callback === 'function') {
                        callback(key, value);
                    }
                });
            };
            //注意,order是用的通用的右侧
            showOrderDetail = (id)=>{
                let {dispatch} = this.props;
                dispatch(AjaxAction.orderDetail(id)).then(()=>{
                    dispatch(AjaxAction.orderTags(id));
                    dispatch(AjaxAction.orderModifyCheck(id));
                    dispatch(actions.showCommonDetail(true));
                });
            };
            handleCancel = () => {
                this.closeAddCommonModal();

            };
            closeAddCommonModal = () => {
                let {dispatch} = this.props;
                dispatch(props.dispatchName ? actions[props.dispatchName](false) : actions.showAddCommon(false));
                console.log('removeCurrent' + getCapital(props.type));
                dispatch(actions['removeCurrent' + getCapital(props.type)]());
                //因为当前是state管理，需要手动清空state的值，否则下次进入，比如新增，会保留之前编辑的某个用户的数据
                this.state = defaultState;
            };
            handleCommon = (handleType)=> {
                let {composed} = this.refs;
                if (!composed.handleData) {
                    console.error("请务必提供该方法：handleData");
                    return;
                }
                let data = composed.handleData(this.state);
                if (false === data) {
                    return;//数据没有处理或者验证没有通过
                }
                let {dispatch} = this.props;
                let _this = this;
                let rowKey = props.rowKey || "id";
                let theId = data[rowKey];

                function doCreate() {
                    delete data[rowKey];

                    dispatch(handleType === "add" ?
                        AjaxAction[props.type + 'Add'](data) :
                        AjaxAction[props.type + "Edit"](theId, data)
                    ).then((dt) => {
                        message.success((handleType === "add" ? "添加" : "修改") + "成功", 1.5, () => {
                            _this.setState(defaultState);
                            _this.closeAddCommonModal();
                            _this.props.addCallback && _this.props.addCallback(dt);
                        });
                    });
                }

                if(data.__confirm) {
                    var text = data.__confirm;
                    delete data.__confirm;

                    Modal.confirm({
                        title:text,
                        onOk:doCreate
                    });
                }
                if(data.__alert) {
                    text = data.__alert;
                    delete data.__alert;

                    Modal.error({
                        title:text,
                        okText:'再看看'
                    });
                }
                else {
                    doCreate();
                }
            };
            editCommon = ()=> {
                this.handleCommon("edit");
            };
            addCommon = () => {
                this.handleCommon("add");
            };

            componentWillReceiveProps(nextProps) {
                let cur = Object.assign({}, nextProps['current']);
                let rowKey = props.rowKey || "id";
                if (cur && cur[rowKey]) {
                    //console.log("Hello", cur);
                    let newProps = cur;
                    if(cur.price){
                        newProps.price = (cur.price/100).toFixed(2);
                    }

                    if(cur[rowKey] == '-1') {
                        delete cur[rowKey];
                    }

                    this.setState(newProps);
                }else{
                    //没有ID的情况被认为是新增，直接吧state赋值成空
                    var result = {};
                    if(typeof nextProps.consumerid != 'undefined') {
                        result.consumerid = nextProps.consumerid;
                    }
                    if(typeof nextProps.consumer != 'undefined') {
                        result.consumer = nextProps.consumer;
                    }
                    this.state = result;
                }
            }

            render() {
                let rowKey = props.rowKey || "id";
                let id = this.state[rowKey];
                return (
                    <Modal title={(id?"编辑":"新增")+props.name}
                           width={650}
                           onOk={id?this.editCommon:this.addCommon}
                           onCancel={this.handleCancel}
                           visible={this.props.showAddCommon}>
                        <Composed
                            ref="composed"
                            state={this.state}
                            addCommon={this.addCommon}
                            setKeyValue={this.setKeyValue}
                            showOrderDetail={this.showOrderDetail}
                            dispatch={this.props.dispatch}
                            key={props.type + "" + id}
                        />
                    </Modal>
                )
            }
        }, null, null, {
            /*withRef: true*/
        })



// WEBPACK FOOTER //
// ./src/components/HighListComponent/Add.js